import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, url, image }) => {
  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title ? `${title} | Satima Technova Solutions` : "Satima Technova Solutions"}</title>
      <meta
        name="description"
        content={description || "Satima Technova Solutions offers web, software, and digital services to help your business grow."}
      />

      {/* Open Graph (OG) tags for social sharing */}
      <meta property="og:title" content={title ? `${title} | Satima Technova Solutions` : "Satima Technova Solutions"} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || window.location.href} />
      <meta property="og:image" content={image || "https://satimatechnova.co.ke/images/default-banner.png"} />

      {/* Twitter card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || "https://satimatechnova.co.ke/images/default-banner.png"} />

      {/* Favicon */}
      <link rel="icon" href="/favicon.png" />

      {/* JSON-LD Structured Data for Google (Organization Logo) */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Satima Technova Solutions",
          "url": "https://www.satimatechnova.co.ke",
          "logo": "https://www.satimatechnova.co.ke/logo.jpeg"
        }
        `}
      </script>
    </Helmet>
  );
};

export default SEO;